import { useRouter } from "next/router";

import MainLearningContent from "@/components/marketing/learning/MainLearningContent";
import LearningClient from "@/client/LearningClient";
import { Course } from "@/types/learning/Course";

type LearningProps = {
  courses: Course[];
};

const LearningTabPage: React.FunctionComponent<LearningProps> = (props) => {
  const router = useRouter();

  return (
    <MainLearningContent {...props} slug={router.query.learning as string} />
  );
};

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" };
}

export const getStaticProps = async () => {
  const learningClient = new LearningClient();
  const coursesIds = LearningClient.listOfCourses;

  return {
    props: { courses: await learningClient.getCollectionsById(coursesIds) },
  };
};

export default LearningTabPage;
